import { gql } from '@apollo/client';

// NOTE: exported for testing purposes only
export const LOG_OUT_USER = gql`
  mutation logOut {
    logOut
  }
`;
